import { render, staticRenderFns } from "./xcRankCard.vue?vue&type=template&id=72ed80ae&scoped=true"
import script from "./xcRankCard.vue?vue&type=script&lang=js"
export * from "./xcRankCard.vue?vue&type=script&lang=js"
import style0 from "./xcRankCard.vue?vue&type=style&index=0&id=72ed80ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed80ae",
  null
  
)

export default component.exports